import type { SettingsInsight } from '@/Client/Widgets/Settings';

/**
 * The insights each Org Settings page can show, in one place (KAIDEV-4345).
 *
 * A page keeps one banner at its top and rotates through whatever its sections have to say,
 * rather than pinning a banner to each section - which put a second one halfway down the
 * Workflow page once Modifiers moved into it.
 */
export const PROJECT_SETTINGS_INSIGHT: SettingsInsight = {
  title: 'Project Settings Insight',
  body:
    'Define your project types by giving each one a short label and description. The project type will appear as the first tag label on every project throughout Kai.',
  dismissCookieKey: 'org-settings-workflow-insight-dismissed',
};

export const MODIFIER_INSIGHT: SettingsInsight = {
  title: 'Modifier Insight',
  body:
    'Modifiers help organize and filter tasks. Financial modifiers have predefined behavior set by Kai. You can choose which modifiers to adopt and what to label them.',
  dismissCookieKey: 'modifiersInsightDismissed',
};
